import { render, staticRenderFns } from "./FormCouples.vue?vue&type=template&id=a0f6d76c&scoped=true"
import script from "./FormCouples.vue?vue&type=script&lang=js"
export * from "./FormCouples.vue?vue&type=script&lang=js"
import style0 from "./FormCouples.vue?vue&type=style&index=0&id=a0f6d76c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f6d76c",
  null
  
)

export default component.exports